declare namespace $ {

	export class $yuf_video_estimate extends $mol_view {
		time_formatted( ): string
		time( ): number
		duration( ): number
		ms_enabled( ): boolean
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=estimate.view.tree.d.ts.map